import { Col, Empty, Row } from 'antd';
import { FC } from 'react';

import InboundTransactionRow from './InboundTransactionRow';

interface InboundTransactionTableProps {
  transactionIds: string[];
  title?: string;
}

const InboundTransactionTable: FC<InboundTransactionTableProps> = ({ transactionIds }) => {
  if (!transactionIds || transactionIds.length === 0) {
    return <Empty description='입고 내역이 없습니다.' />;
  }

  return (
    <div
      style={{
        border: '1px solid rgba(5, 5, 5, 0.06)',
        borderRadius: 4,
        padding: 8,
        flex: 1,
        overflow: 'scroll',
      }}>
      <Row
        gutter={[16, 8]}
        style={{
          fontWeight: 'bold',
          marginBottom: 8,
          padding: '4px 8px',
          borderBottom: '1px solid #f0f0f0',
        }}>
        <Col span={12}>재고명</Col>
        <Col span={3}>변경량</Col>
        <Col span={3}>단위</Col>
        <Col span={3}>요청 값</Col>
        <Col span={3}>상태</Col>
      </Row>
      <div>
        {transactionIds.map((id) => (
          <InboundTransactionRow key={id} transactionId={id} />
        ))}
      </div>
    </div>
  );
};

export default InboundTransactionTable;
